import { jsx } from '@emotion/core'; // eslint-disable-next-line @typescript-eslint/camelcase
// @ts-ignore

import { search_16 } from '@trustpilot/icons';
import Input from '../Input';
import { forwardRef } from 'react';
var searchStyles = {
  '&[type="search"]': {
    padding: '10px 40px'
  }
};
export var Search = forwardRef(function (_a, ref) {
  var className = _a.className,
      placeholder = _a.placeholder,
      _b = _a.value,
      value = _b === void 0 ? '' : _b,
      onChange = _a.onChange,
      onSubmit = _a.onSubmit,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c;
  return jsx(Input, {
    ref: ref,
    css: searchStyles,
    type: "search",
    icon: search_16,
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    onEnterPress: function onEnterPress() {
      return onSubmit(value);
    },
    size: size,
    className: className
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Search/index.js
// module id = 200
// module chunks = 0